<script setup lang="ts">
import { defineProps } from 'vue'
import { LayerControl, LayerIdentifier } from '~/types/map'

const layerControls = inject<{
  registerLayer: (layer: LayerControl) => void
  updateLayerVisibility: (layerIdentifier: LayerIdentifier, visible: boolean) => void
}>('layerControls')

const props = defineProps<{
  name: string
  identifier: LayerIdentifier
  visible: boolean
  dataLegendLabel?: string
}>()
const layerIsVisible = ref(props.visible)

onMounted(() => {
  if (!layerControls) return
  layerControls.registerLayer({
    name: props.name,
    identifier: props.identifier,
    visible: layerIsVisible,
    dataLegendLabel: props?.dataLegendLabel,
  })
  layerControls.updateLayerVisibility(props.identifier, layerIsVisible.value)
})

watch(layerIsVisible, () => {
  layerControls && layerControls.updateLayerVisibility(props.identifier, layerIsVisible.value)
})

provide<{
  visible: Ref<boolean>
  name: string
  dataLegendLabel?: string
  identifier: LayerIdentifier
}>('layerControl', {
  visible: layerIsVisible,
  name: props.name,
  dataLegendLabel: props.dataLegendLabel,
  identifier: props.identifier,
})
</script>
<template>
  <div>
    <slot />
  </div>
</template>
<style scoped></style>
